import type { DialoguePool } from '@/state/types';

export const L15_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Match the frequency. The oscilloscope has expectations. Low ones.',
    'Up and down. Like breathing, but coordinated.',
    'You\u2019re not dancing. You\u2019re hovering with dread. Try actual motion.',
  ],
  tokenLoss: [
    'Off pattern. A waveform wince.',
    'Arrhythmic. Your ancestors could keep time. Briefly. On horses.',
    'A token lost to poor phrasing. Try again without the stiffness.',
  ],
  solution: [
    'Matched. A coincidence I am choosing to file under \u2018Extreme Luck.\u2019.',
    'You danced. I\u2019d applaud, but I\u2019m currently occupied by a very interesting wall.',
    'Done. I\u2019ll celebrate by deleting a very small, very unimportant file.',
  ],
  spite: ['Still dancing. The scope wags along. Privately.'],
};
